import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import { CheckCircleOutline, Home } from '@mui/icons-material';

const ClientNewCompletePage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Container maxWidth="sm" sx={{ mt: 8, mb: 8, textAlign: 'center' }}>
        <Box>
          <CheckCircleOutline color="success" sx={{ fontSize: 64 }} />
          <Typography variant="h1" component="h1" sx={{ mt: 2, mb: 2 }}>
            送信完了
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            ご登録いただきありがとうございました。<br />
            当社にて審査・確認のうえ、後日改めてご連絡させていただきます。
          </Typography>
          <Box display="flex" justifyContent="center" gap={2}>
            <Button
              variant="contained"
              color="primary"
              endIcon={<Home />}
              onClick={() => navigate('/')}
            >
              トップページへ戻る
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default ClientNewCompletePage;
